import _ from 'lodash'
import { mapGetters } from 'vuex'
// import Qs from 'qs'

export default {
  computed: {
    ...mapGetters({
      queryFilters: 'search/queryFilters'
    })
  },
  methods: {
    _querySerialization: function (form) {
      const query = {
        search: form.search.name || form.search,
        source: form.search.source,
        searchId: form.search.id,
        externalId: form.search.externalId,
        searchType: form.search.type,
        start: this.$options.filters.toDate(form.date.start, 'YYYY-MM-DD'),
        end: this.$options.filters.toDate(form.date.end, 'YYYY-MM-DD'),
        room: form.people.room,
        adult: form.people.adult,
        child: form.people.child,
        ages: form.people.childrenAge.join(',')
      }

      // TODO Add facilities to URL
      // console.log(this.queryFilters)
      // console.log('queryFilters', Qs.parse(Qs.stringify(this.queryFilters, { arrayFormat: 'indices', skipNulls: false })))
      // console.log('queryFilters', Qs.parse(Qs.stringify(this.queryFilters, { arrayFormat: 'indices', skipNulls: true })))

      return _.pickBy(query, _.identity)
    },
    _onClickSearchButton: function (form) {
      // TODO 分 type area/hotel/events
      const query = {
        // ...this.$route.query,
        ...this._querySerialization(form),
        trigger: true
      }

      console.debug('[clicked search button]', query)
      switch (query.searchType) {
        case 'area':
        case 'sights':
        case 'landmark':
        case 'traffic':
        case 'county':
        case 'township':
        case 'hotel':
          if (this.$route.name === 'HotelsMap') {
            this.$router.push({
              name: 'HotelsMap',
              query
            })
            break
          }
          if (this.$route.name === 'HotelDetail' && this.$route.params.hotelId === query.externalId) {
            this.$router.push({
              name: 'HotelDetail',
              params: {
                hotelId: query.externalId
              },
              query
            })
            break
          }
          this.$router.push({
            name: 'HotelsList',
            query
          })
          break
        case 'events':
          break
        default:
          console.error('[WARNING] 模糊搜尋')
          this.$router.push({
            name: 'Collects',
            query
          })
          break
      }
    }
  }
}
